import { useAtom } from "jotai";
import styled from "styled-components";
import { theme } from "styles/Theme";
import { darkModeAtom } from "utils/ThemeAtom";

function NotFOund() {
  const [dark] = useAtom(darkModeAtom);

  return (
    <Nothing $dark={dark}>
      <strong>Nothing Here</strong>
    </Nothing>
  );
}

export default NotFOund;

const Nothing = styled.div<{ $dark: boolean }>`
  height: calc(100vh - 92px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $dark }) => ($dark ? "#fff" : theme.blackColor)};
  background-color: ${({ $dark }) => ($dark ? theme.blackColor : "#fff")};
`;
